import { theme as baseTheme } from '../aidu/index.js';
export const colors = {
  ...baseTheme.colors,
  contentBrand: '#013E7A',
  interactionSuccess: '#90C407',
  interactionSuccessHover: '#79A713',
  interactionSuccessPressed: '#618A1E',
  interactionPrimary: '#E87108',
  interactionPrimaryHover: '#CF6507',
  interactionSecondary: '#05A8E6',
  interactionSecondaryHover: '#0495CD',
  backgroundBrand: '#013E7A',
  backgroundBrandDark: '#00305F',
  backgroundInteractionSecondaryTransparentDark: '#05A8E6CC',
  backgroundInteractionSecondaryTransparentLight: '#05A8E64D',
  backgroundStateSelectedTransparent: '#05A8E61A',
  backgroundStateSelected: '#E6F7FD',
  backgroundOverlay: '#013E7ACC',
  borderSelection: '#05A8E6',
  systemError: '#FC3403',
  systemErrorAlert: '#CE2727',
  systemErrorBackground: '#FBEAEA',
  systemPositive: '#90C407',
  systemPositiveHover: '#79A713',
  systemPositiveAlert: '#618A1E',
  systemPositiveBackground: '#D4EDAC',
  systemWarning: '#F8880A',
  systemWarningAlert: '#946700',
  systemWarningBackground: '#FFE9B6',
  brandA: '#013E7A'
};